import React from 'react';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';
import Modal from '../Modal';
import Button from '../Button';
import { helpLinks } from '../../constants';

import * as actions from '../../actions/index';

const INITIAL_STATE = {
  urlMovie: null
};

class HelpModal extends React.PureComponent {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentWillReceiveProps(props) {
    const { link } = props;
    const { link: oldLink } = this.props;
    if (link && !oldLink && link) {
      if (helpLinks[link].length > 1) {
        this.setState({ urlMovie: null });
      } else {
        this.setState({ urlMovie: helpLinks[link][0].url });
      }
    }
  }

  newOnClose = () => {
    const { handleClose, link } = this.props;
    const { urlMovie } = this.state;
    if (urlMovie && helpLinks[link].length > 1) {
      this.setState({ urlMovie: null });
    } else {
      return handleClose();
    }
  };

  render() {
    const { link, handleClose } = this.props;
    const { urlMovie } = this.state;
    return (
      <>
        <Modal
          color='secondary'
          title='Support Dishop'
          header
          size='lg'
          handleClose={() => handleClose()}
          onClick={() => this.newOnClose()}
          isOpen={!!link}
          width='700px'
          btnTxt='Retour'
        >
          {!urlMovie ? (
            helpLinks[link] &&
            helpLinks[link].map(help => (
              <Button
                color='secondary'
                onClick={() => this.setState({ urlMovie: help.url })}
                outlined
                style={{ width: '100%', borderRadius: '0px' }}
                className='mb-2'
              >
                <div className='row ml-0 mr-0 align-items-center'>{help.name}</div>
              </Button>
            ))
          ) : (
            <ReactPlayer url={urlMovie} controls width='100%' />
          )}
        </Modal>
      </>
    );
  }
}

function mapStateToProps({ user }) {
  const { dataHelpModalLink: link = null } = user;
  return {
    link
  };
}

export default connect(mapStateToProps, actions)(HelpModal);
